"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
var _react = _interopRequireDefault(require("react"));
function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", Object.assign({
    width: "16",
    height: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-28 -18)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    stroke: "#DCE2E3",
    fill: "#FFF",
    x: ".5",
    y: ".5",
    width: "510",
    height: "75",
    rx: "2"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(28 18)"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#00C0E0",
    cx: "8",
    cy: "8",
    r: "8"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "#FFF",
    strokeWidth: "2"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8 12.667V6.833M8 5.375v-1.75 1.75z"
  })))));
}
//# sourceMappingURL=Info.js.map